import React from 'react';
import { useTranslation } from 'react-i18next';
import { Message } from './Message';
import { jsx as _jsx } from "react/jsx-runtime";
export const ErrorMessage = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(Message, {
    text: t('global.unknownErrorOccurred'),
    type: "Error"
  });
};